import type { SVGProps } from 'react';
const SvgInfoCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <g clipPath="url(#info-circle_svg__a)">
      <path
        fill="currentColor"
        fillOpacity={0.45}
        d="M8 0a8 8 0 1 0 .001 16.001A8 8 0 0 0 8 0m0 14.643A6.644 6.644 0 0 1 8 1.357a6.644 6.644 0 0 1 0 13.286"
      />
      <path
        fill="currentColor"
        fillOpacity={0.45}
        d="M7.143 4.857a.857.857 0 1 0 1.714 0 .857.857 0 0 0-1.714 0m1.285 2h-.857A.143.143 0 0 0 7.428 7v4.857c0 .079.065.143.143.143h.857a.143.143 0 0 0 .143-.143V7a.143.143 0 0 0-.143-.143"
      />
      <path
        stroke="currentColor"
        strokeOpacity={0.45}
        strokeWidth={0.001}
        d="M8 .001a8 8 0 0 1 1.218.092 7.95 7.95 0 0 1 4.16 1.986q.284.258.543.542a8 8 0 0 1 2.037 4.562 8.1 8.1 0 0 1-.444 3.567 8 8 0 0 1-2.135 3.17 8 8 0 0 1-4.562 2.038 8.1 8.1 0 0 1-3.567-.444 8 8 0 0 1-3.17-2.135A8 8 0 0 1 .041 8.817 8.1 8.1 0 0 1 .486 5.25a8 8 0 0 1 2.135-3.17A8 8 0 0 1 7.183.041Q7.585.002 8 .001Zm0 1.355a6.7 6.7 0 0 0-2.284.404A6.67 6.67 0 0 0 1.49 6.66a6.67 6.67 0 0 0 .269 3.623A6.67 6.67 0 0 0 6.66 14.51a6.67 6.67 0 0 0 3.623-.269A6.67 6.67 0 0 0 14.51 9.34a6.67 6.67 0 0 0-.269-3.623A6.67 6.67 0 0 0 9.34 1.49 6.7 6.7 0 0 0 8 1.356Zm.429 5.501A.142.142 0 0 1 8.57 7v4.857a.14.14 0 0 1-.142.142H7.57a.14.14 0 0 1-.13-.087l-.012-.055V7c0-.059.036-.11.087-.13l.055-.013zM8 4.001a.855.855 0 0 1 .856.856l-.003.084A.856.856 0 1 1 8 4.001Z"
      />
    </g>
    <defs>
      <clipPath id="info-circle_svg__a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgInfoCircle;
